import React, { useState } from 'react';
import { FormDialog } from 'components';
import { FinancialsForm } from 'components/Forms';
import { FinancialsNameDialogProps } from './FinancialsNameDialog.props';
import { FinancialsNameDialogFormState } from '../../balance-sheet/types';

const FinancialsNameDialog = ({ open, onClose, onSave, versionName }: FinancialsNameDialogProps) => {
  const [formState, setFormState] = useState<FinancialsNameDialogFormState>();

  const tableTerms = {
    tableName: 'Financial Statement',
  };

  return (
    <FormDialog
      open={open}
      title="Edit Financial Statement name"
      editMode={false}
      onClose={onClose}
      onSave={() => onSave(formState?.values?.name)}
      isValid={formState?.isValid}>
      <FinancialsForm
        tableTerms={tableTerms}
        initialValues={{ name: versionName }}
        onFormChange={state => setFormState(state as FinancialsNameDialogFormState)}
      />
    </FormDialog>
  );
};

export default FinancialsNameDialog;
